export const darkTheme = {
  mode: "dark",
  primaryColor: "#222",
  accentColor: "#f6b846",
  backgroundColor: "#161616",
  primaryTextColor: "rgba(255, 255, 255, 0.9)",
  secondaryTextColor: "rgba(255, 255, 255, 0.55)",
  primaryButtonColor: "#f6b846",
  secondaryButtonColor: "#2f2f2f",
  borderRadius: "4px",
  borderColor: "#957335",
  primaryBoxShadow: 'rgba(197, 202, 213, 0.15)',
  accentBoxShadow:  `linear-gradient(
    135deg,
    rgba(246, 184, 70, 0.4) 0%,
    rgba(246, 184, 70, 0.01) 100%
  );`,
  navbarBoxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.51)',
  inactiveColor: "#3e4148",
  backgroundStrokeColor: "#f6b846",
  scrollbarColor: 'rgba(255, 255, 255, 0.25)',
};

export const lightTheme = {
  mode: "light",
  primaryColor: "#FDFCF5",
  accentColor: "#F0A500",
  backgroundColor: "#FCE9A7",
  primaryTextColor: "#2B2B2B",
  secondaryTextColor: "#2B2B2B",
  primaryButtonColor: "#ebab33",
  secondaryButtonColor: "#F8F6E7",
  borderRadius: "4px",
  borderColor: "#ece2c9",
  primaryBoxShadow: 'rgba(221, 183, 85)',
  accentBoxShadow: `linear-gradient(
    135deg,
    rgba(228, 167, 10, 0.8) 0%,
    rgba(221, 183, 85, 0.01) 100%
  );`,
  navbarBoxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.51)',
  inactiveColor: "#F9E6B7",
  backgroundStrokeColor: "#D18716",
  scrollbarColor: 'rgba(228, 167, 10, 0.8)',
};

export const blueDarkTheme = {
  primaryColor: '#182525',
  accentColor: '#17D7DE',
  backgroundColor: "#161616",
  primaryTextColor: "rgba(255, 255, 255, 0.9)",
  secondaryTextColor: "rgba(255, 255, 255, 0.55)",
  borderRadius: "4px",
  accentBoxShadow: `linear-gradient(
    135deg,
    rgba(23, 215, 222, 0.4) 0%,
    rgba(23, 215, 222, 0.01) 100%
  );`,
  inactiveColor: "#3e4148"
};